import { Modal, Typography } from 'antd'
import Button from 'components/button/Button'
import { IconCancel } from 'components/icons'
interface IProps {
  loading: boolean
  visibility: boolean
  isApproved: boolean
  onCancel: () => void
  onAccept: (isApproved: boolean) => void
}

function ModalOrderCancellation(props: IProps) {
  const { onAccept, onCancel, visibility, loading, isApproved } = props
  return (
    <Modal
      data-testid="modal_orders_status_confirmation"
      centered
      closable={!loading}
      onCancel={onCancel}
      open={visibility}
      footer={null}
      className="modal-orders-status-confirmation"
      closeIcon={<IconCancel strokeWidth="2" color="black" />}
    >
      <div className="flex flex-col">
        <Typography.Paragraph className="text-lg font-semibold leading-5 text-gray-700">
          {isApproved ?
            'Apakah Anda yakin untuk menyetujui Pembatalan Pesanan ini? Order yang dibatalkan tidak bisa diproses kembali.'
            : 'Apakah Anda yakin ingin menolak permintaan pembatalan pesanan ini?'}
        </Typography.Paragraph>
        {loading ? (
          <div data-testid="loader" className="flex items-center justify-center mt-4 text-center">
            <div className="loader" />
          </div>
        ) : (
          <div className="flex mt-4">
            <Button
              disabled={loading}
              block={true}
              onClick={onCancel}
              data-testid="btn_cancel"
              className="inline-block mr-4"
              label="KEMBALI"
            />
            <Button
              disabled={loading}
              block={true}
              onClick={() => onAccept(isApproved)}
              data-testid="btn_accept"
              className="inline-block"
              iconPosition="right"
              label="KONFIRMASI"
              variant="solid-primary"
            />
          </div>
        )}
      </div>
    </Modal>
  )
}

export default ModalOrderCancellation
